/**
 * Canonical enabled languages configuration
 * 
 * This is the single source of truth for all supported programming languages.
 */

import { python } from '@codemirror/lang-python';
import type { LanguageConfig, LanguageId } from '../types/language';

export const DEFAULT_TAB_SIZE = 4;

/**
 * Configuration for all enabled languages
 */
export const ENABLED_LANGUAGES: Record<LanguageId, LanguageConfig> = {
  python: {
    id: 'python',
    name: 'Python',
    codeMirrorLang: () => python(),
    runner: 'pyodide',
    indentUnit: ' '.repeat(DEFAULT_TAB_SIZE),
    judge0Id: 71, // Python 3.8.1
  },
} as const;

/**
 * Get language configuration by ID
 */
export function getLanguageConfig(languageId: LanguageId): LanguageConfig {
  const config = ENABLED_LANGUAGES[languageId];
  if (!config) {
    throw new Error(`Language "${languageId}" is not enabled`);
  }
  return config;
}

/**
 * Get all enabled language IDs
 */
export function getEnabledLanguageIds(): LanguageId[] {
  return Object.keys(ENABLED_LANGUAGES) as LanguageId[];
}

export const DEFAULT_LANGUAGE: LanguageId = 'python';

